/**
 * Possible mutually exclusive statuses of the top frame.
 *
 * Note this is different than the worker status.
 */
export const enum EditorStatus {
  /** The default editor status. This is the status used before the Jupyter URL exists. */
  QUEUED = "QUEUED",
  /** The Jupyter URL / Kernel run ID exist and the Kernel is starting up the Jupyter frame. */
  STARTING = "STARTING",
  /** The notebook is running / connected to the back-end. */
  RUNNING = "RUNNING",
  /** The notebook is disconnected. No run ID exists. */
  STOPPED = "STOPPED",
  /** The notebook is in an errored state. This state is potentially recoverable. */
  ERROR = "ERROR",
  /** The notebook is in a fatal errored state. This state is not recoverable and the Kernel must be restarted (from banner click). */
  FATAL = "FATAL",
}
